/**
 * queue #680 §R680-2 — 업로더 표시명 해석.
 *
 * BE 가 응답 파생 필드 `exportedByDisplay` 를 내려주면 그대로 쓴다(신규 배포분).
 * 필드가 없거나 공백인 구버전 응답은 FE 에서 하위호환 fallback 을 적용한다:
 * `exportedBy` 가 순수 숫자 문자열(내부 사용자 PK)이면 노출을 피하고 'ci-bot' 으로,
 * 그 외에는 `exportedBy` 원문을 그대로 표시한다.
 */
export function resolveExportedByDisplay(
  exportedBy: string,
  exportedByDisplay?: string
): string {
  if (exportedByDisplay && exportedByDisplay.trim() !== '') {
    return exportedByDisplay;
  }
  if (/^\d+$/.test(exportedBy)) {
    return 'ci-bot';
  }
  return exportedBy;
}
